import { resolveMerchantMid } from "utils/resolveMerchantMid";

const STORAGE_KEY = "basil_online_order_menu_cache_v1";

type WrappedMenu = { merchantKey: string; payload: unknown };

let memory: WrappedMenu | null = null;

function normalizedMidKey(mid: string): string {
  return mid.trim().toLowerCase();
}

/**
 * Call after a successful `/onlineOrder/menu` response so product detail and deep links
 * can reuse the full payload without calling the API again.
 */
export function setOnlineMenuCacheFromResponse(payload: unknown): void {
  if (payload == null) return;
  const mid = resolveMerchantMid();
  if (!mid) return;
  const wrapped: WrappedMenu = {
    merchantKey: normalizedMidKey(mid),
    payload,
  };
  memory = wrapped;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(wrapped));
  } catch {
    // Quota or private mode — in-memory cache still helps for SPA navigation.
  }
}

/** Full menu API body (items, onlineOrderSettings, …) for the current merchant. */
export function getOnlineMenuCachedPayload(): unknown | null {
  const mid = normalizedMidKey(resolveMerchantMid());
  if (!mid) return null;
  if (memory && memory.merchantKey === mid) {
    return memory.payload;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const w = JSON.parse(raw) as WrappedMenu;
    if (!w?.payload || w.merchantKey !== mid) return null;
    memory = w;
    return w.payload;
  } catch {
    return null;
  }
}
